<app-loader *ngIf="isLoading"></app-loader>
<div class="row mb-3">
  <div class="col-md-6">
    <div class="d-flex align-items-center mb-3 mb-md-0">
      <div class="ms-2">
        <img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2 cursor-pointer" />
      </div>
      <div>
        <h4 class="q-heading mb-0" style="font-size: 25px;">
          {{ "MANAGEDEVICE.LOCATEYOURDEVICE" | translate }}
        </h4>
      </div>
    </div>



  </div>
  <div class="col-md-6">
    <div class="d-flex justify-content-end align-items-center">
      <!-- <div class="cursor-pointer me-3">
        <form [formGroup]="restorePublishForm">
          <select class="bg-transparent form-select" formControlName="mobileDeviceName"
            (change)="onMobileDeviceSelect($event)">
            <option *ngFor="let item of mobileDevice" [value]="item.id">
              {{ item.deviceName }}
            </option>
          </select>
        </form>
      </div> -->
      <div class="cursor-pointer">
        <button type="button" (click)="sendCommand('TRACE')" class="bg-orgclr submit-btn shadow-none">
          {{ "MANAGEDEVICE.LOCATEDEVICE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="commandsBG-WHITE mb-5 mt-4">
  <div class="row mb-4">
    <div class="col-12 mb-0 text-end">
      <div class="d-flex justify-content-end align-items-center">

        <div class="modal" id="locatePopup" data-bs-backdrop="static">
          <div class="modal-dialog modal-dialog-centered ">
            <ng-container>
              <div
                class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
                <div class="mt-3">
                  <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
                </div>
                <h5 class="fw-bold mt-3 mb-2">
                  {{ "MANAGEDEVICE.lOCTIONENABLE" | translate }}
                </h5>
                <p class="text-sm p-xl-2">
                  {{ "MANAGEDEVICE.LOCATIONDECP" | translate }}

                </p>

                <div class="d-flex justify-content-center text-center">
                  <div class="me-3">
                    <button class="submit-btn bg-orgclr" data-bs-dismiss="modal">
                      {{ "MANAGEDEVICE.ENABLE" | translate }}
                    </button>

                  </div>
                  <div>
                    <button type="button" class="cancel-btn bg-cancelbtn mb-4" data-bs-dismiss="modal">
                      {{ "PARENTALREPORTS.CANCEL" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="getLocationHistory?.length!=0">

      <!-- <div class="d-flex justify-content-start mt-3 mb-1 ">
        <h5 class="mb-1 fw-bold" style="margin-right: 10px;font-size: 18px;">
          {{ "MANAGEDEVICE.LASTLOCATION" | translate }}
        </h5>
        <h5 class="d-flex justify-content-center " style="font-size: 18px;">{{
          getLocationHistory[0]?.locationName == null
          ? "N/A"
          : (getLocationHistory[0]?.locationName | translate)
          }}</h5>
      </div> -->

      <google-map [options]="mapOptions" width="100%">
        <map-marker #marker="mapMarker" *ngFor="let spot of spots" [position]="{ lat: spot.lat, lng: spot.lng }"
          [options]="markerOptions" [clickable]="true" (mapClick)="openInfoWindow(marker, infoWindow)">
          <map-info-window #infoWindow="mapInfoWindow">
            <span class="textColorGreenVogue">{{ spot.locname }}</span>
          </map-info-window>
        </map-marker>
      </google-map>
    </div>
    <div class="row bg-white mt-3 mb-5 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
      *ngIf="getLocationHistory?.length === 0">
      <div class="col-md-12">
        <div class="nodatafounddiv">
          <img [src]="'IMAGES.NORECORDFOUNDIMG'|translate" class="img-fluid" alt="" />
          <h1 class="mt-4">
            <app-main-heading>
              <span title>{{
                "LICENSESUMMARY.NOLOCATIONHISTORYFOUND" | translate
                }}</span>
            </app-main-heading>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-6">
      <h4 class="q-heading mb-4">
        {{ "MANAGEDEVICE.LOCATIONHISTORY" | translate }}
      </h4>
    </div>
    <!-- <div class="col-6 p-md-0 text-end">
      <button type="button" (click)="checkBeforeDeleting()" class="q-form-white-submit bg-transparent-gray me-3">
        <span><img [src]="'IMAGES.TRASHIMG'|translate" alt="" class="trash-margin" /></span>
        {{ "MANAGEDEVICE.DELETEALL" | translate }}
      </button>
    </div> -->
  </div>


  <div class="modal" id="deletePopup" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered ">
      <ng-container *ngIf="deviceId">
        <div
          class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
          <div class="mt-3">
            <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
          </div>
          <h5 class="fw-bold mt-3 mb-2">
            {{ "MANAGEUSER.DELETEUALLHISTORY" | translate }}?
          </h5>
          <p class="text-sm">
            {{ "MANAGEUSER.AREYOUSURETODELETE" | translate }}
          </p>


          <div class="d-flex justify-content-center text-center">
            <div class="me-3">
              <button class="submit-btn bg-orgclr" (click)="deleteLocation()">
                {{ "SUCESSMESSAGE.YES" | translate }}
              </button>
            </div>
            <div>
              <button type="button" class="cancel-btn bg-cancelbtn mb-4" data-bs-dismiss="modal">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-9 mb-3 mb-md-0">
      <div class="d-flex align-items-top align-items-md-center flex-wrap actionDiv">
        <!-- <div>
          <h5 class="mb-0 textColorGreenVogue"><strong>{{ "MANAGEDEVICE.ACTION" | translate }} :</strong></h5>
        </div> -->
        <div>
          <button [ngClass]="traceOperation != 'All'?'buttonsClick' : 'buttonsClickfocus'" (click)="getLocation('All')"
            class="filter-pill-btn">
            <span style="font-size: 15px;">{{ "MANAGEDEVICE.ALL" | translate }}</span>
          </button>
        </div>

        <!-- <div class="mx-2 d-flex justify-content-center align-items-scenter gap-1"> -->

        <div class="ms-0 ms-md-3">
          <span style="padding-left: 10px;"></span>
          <button [ngClass]="traceOperation != 'BLOCK'? 'buttonsClick' : 'buttonsClickfocus'"
            (click)="getLocation('BLOCK')" class="lock-device-btn">
            <img src="./assets/images/lockImage.svg" *ngIf="clickLockDevice!=0" />
            <img src="./assets/images/lockBlackImage.svg" *ngIf="clickLockDevice==0" />

            <span style="font-size: 15px; margin-left: 5px; padding-right: 5px;">{{ "MANAGEDEVICE.LOCKDEVICE" |
              translate }}</span>
          </button>
        </div>
        <!-- <div class="d-flex flex-wrap flex-md-row flex-column">
          <div class="mx-2 d-flex justify-content-center align-items-center gap-1">
            <img [src]="'MANAGEDEVICE.REFRESHIMG'|translate" alt="" />
            <span>{{ "MANAGEDEVICE.LOCATEDEVICE1" | translate }}</span>
          </div>
        </div> -->
        <div class="ms-0 ms-md-3">
          <span style="padding-left: 10px;"></span>
          <button [ngClass]="traceOperation != 'TRACE'?'buttonsClick' : 'buttonsClickfocus'"
            (click)="getLocation('TRACE')" style="border-radius: 100px;height: 35px;">
            <img src="./assets/images/refreshImage.svg" alt="" *ngIf="clickShowTrace==0" />
            <img src="./assets/images/refreshWhiteImage.svg" alt="" *ngIf="clickShowTrace!=0" />
            <span style="font-size: 15px; margin-left: 5px;">{{ "MANAGEDEVICE.LOCATEDEVICE1" | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="col-md-3 text-end">
      <select name="locationFilterType" [(ngModel)]="locationFilterType" (change)="onDaysDropDownSelect($event)">
        <option *ngFor="let period of daysDropDown" [value]="period.id">
          {{ period.value }}
        </option>
      </select>
    </div>
  </div>
  <div class="table-responsive my-3">
    <table class="table activity-table" aria-describedby="Location History">
      <thead class="activity-header">
        <tr>
          <!-- <th>{{ "MANAGEDEVICE.ACTION" | translate }}</th> -->
          <th>
            <div class="">
              <input type="checkbox" id="cb3" [checked]="allChecked" (change)="
              onDeviceClick(
                $event,
                getLocationHistory,
                'multiple'
              )
            " class="align-middle" />
            </div>



          </th>
          <th>{{ "MANAGEDEVICE.LOCATIONNAME" | translate }}</th>
          <th>{{ "MANAGEDEVICE.DATEANDTIME" | translate }}</th>
          <th class="cursor-pointer">{{ "MANAGEDEVICE.DELETE" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of getLocationHistory" class="text-capitalize bg-white ">

          <td class="pe-0">
            <div class="d-flex justify-content-sm-between align-items-center">
              <input type="checkbox" id="cb3" [checked]="item.isChecked"
                (change)="onDeviceClick($event, item, 'single')" name="ritem" class="me-3 align-middle" />
              <label for="ritema"></label>

              <div id="tableFilter" *ngIf="item.action === 'TRACE_SETTING'">
                <img [src]="'MANAGEDEVICE.REFRESHIMG' | translate" alt="" />
              </div>
              <div *ngIf="item.action === 'BLOCK'">
                <img [src]="'MANAGEDEVICE.DELETELOCATIONIMG' | translate" alt="" />
              </div>
              <div *ngIf="item.action === 'TRACE'">
                <img [src]="'MANAGEDEVICE.REFRESHIMG' | translate" alt="" />
              </div>
            </div>

            <!-- <div *ngIf="item.action === 'TRACE_SETTING'">
              <img [src]="'MANAGEDEVICE.REFRESHIMG' | translate" alt="" />
            </div>
            <div *ngIf="item.action === 'BLOCK'">
              <img [src]="'MANAGEDEVICE.DELETELOCATIONIMG' | translate" alt="" />
            </div>
            <div *ngIf="item.action === 'TRACE'">
              <img [src]="'MANAGEDEVICE.REFRESHIMG' | translate" alt="" />
            </div> -->
          </td>
          <td class="textColorGreenVogue">
            {{
            item?.locationName == null
            ? "N/A"
            : (item?.locationName | translate)
            }}
          </td>

          <td class="textColorGreenVogue">
            {{
            item?.dateAndTime == null
            ? "N/A"
            : (item?.dateAndTime | translate)
            }}
          </td>
          <td>
            <span (click)=" deleteLocationByLocationId(item.id)" class="col-xl-1 col-lg-4 col-sm-1 cursor-pointer ">
              <span> <img src="./assets/images/DeleteIcon.svg" alt="" /></span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row bg-white mt-3 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
      *ngIf="getLocationHistory?.length === 0">
      <div class="col-md-12">
        <h1 class="mt-4">
          <app-main-heading>
            <span title>{{ "ACTIVITYHISTORY.NOLOCATIONHISTORYFOUND" | translate }}</span>
          </app-main-heading>
        </h1>
      </div>
    </div>

  </div>
  <div class="d-flex justify-content-between flex-wrap p-0" *ngIf="showPage">
    <div class="d-flex align-items-center mb-3 mb-md-0">
      <div class="me-2">
        <h6 class="mb-0 fw-bold">{{ "ACTIVITYHISTORYMAIN.SHOW" | translate }}</h6>
      </div>
      <div>
        <select class="rounded-8 paginationSelect bg-white fw-bold" name="records" [(ngModel)]="pageSize" id="records"
          (ngModelChange)="pageSizeList($event)">
          <option value="10">{{ "ACTIVITYHISTORYMAIN.10" | translate }}</option>
          <option value="25">{{ "ACTIVITYHISTORYMAIN.25" | translate }}</option>
          <option value="50">{{ "ACTIVITYHISTORYMAIN.50" | translate }}</option>
          <option value="100">{{ "ACTIVITYHISTORYMAIN.100" | translate }}</option>
        </select>
      </div>
    </div>
    <div class="p-0 paginationDiv">
      <ngb-pagination [collectionSize]="totalItemsTemp" [(page)]="currentPage" [maxSize]="3" [rotate]="true"
        (pageChange)="pageChanged($event)" [ellipses]="true" [boundaryLinks]="true"></ngb-pagination>
    </div>
  </div>
</div>